var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.downloadData)?_c('div',{staticStyle:{"text-align":"center","cursor":"pointer"}},[_c('button',{staticClass:"btn btn-success mt-4",attrs:{"type":"button","id":"toastr-danger-top-right"},on:{"click":function($event){return _vm.JSON2Excel(_vm.downloadData, _vm.titulo, _vm.headers)}}},[_vm._v("Gerar Excel")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }